export const COHORTE_STATUTS_MANUELS = ['OUVERTE', 'FERMEE'];

export const COHORTE_STATUT_LABELS = {
  OUVERTE: 'Ouverte',
  FERMEE: 'Fermée',
  EN_COURS: 'En cours',
  TERMINEE: 'Terminée',
};

export function toCalendarDateKey(d) {
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '';
  return date.toISOString().slice(0, 10);
}

/** @returns {'AVANT' | 'EN_COURS' | 'APRES'} */
export function getCohortePhase(dateDebut, dateFin, now = new Date()) {
  const today = toCalendarDateKey(now);
  const debut = toCalendarDateKey(dateDebut);
  const fin = toCalendarDateKey(dateFin);
  if (!today || !debut || !fin) return 'AVANT';
  if (today < debut) return 'AVANT';
  if (today > fin) return 'APRES';
  return 'EN_COURS';
}

export function getManualInscriptionStatut(storedStatut) {
  return String(storedStatut ?? 'OUVERTE').toUpperCase() === 'FERMEE' ? 'FERMEE' : 'OUVERTE';
}

export function resolveEffectiveCohorteStatut(dateDebut, dateFin, storedStatut, now = new Date()) {
  const phase = getCohortePhase(dateDebut, dateFin, now);
  if (phase === 'APRES') return 'TERMINEE';
  if (phase === 'EN_COURS') return 'EN_COURS';
  return getManualInscriptionStatut(storedStatut);
}

export function isCohorteStatutAutomatique(phase) {
  return phase === 'EN_COURS' || phase === 'APRES';
}

export function cohorteStatutAutomatiqueLabel(phase) {
  if (phase === 'EN_COURS') return 'En cours (automatique selon les dates)';
  if (phase === 'APRES') return 'Terminée (automatique selon les dates)';
  return null;
}
